<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link :to="{ name: 'Organizations', query: { page: this.$route.query.page } }">Организации</router-link> &raquo; <span>{{ item.nameFull ? item.nameFull : 'Создание новой организации' }}</span>
<!--        <template v-if="item && item.name">{{ item.name }}</template>-->
      </template>
      <h2>Карточка организации</h2>
    </page-header>
    <div class="nav-inner page-header">
      <ul class="nav nav-tabs nav-justified align-items-center">
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab1')"
              :class="{ active: isActive('tab1') }"
              href="#tab1"
          >Общая информация</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab2')"
              :class="{ active: isActive('tab2') }"
              href="#tab2"
          >Услуги</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab3')"
              :class="{ active: isActive('tab3') }"
              href="#tab3"
          >Расписание специалистов</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab4')"
              :class="{ active: isActive('tab4') }"
              href="#tab4"
          >Реабилитационные мероприятия</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab5')"
              :class="{ active: isActive('tab5') }"
              href="#tab5"
          >Карта</a
          >
        </li>
      </ul>
    </div>
    <div class="card" v-if="item">
      <div>
        <div class="tab-content" id="myTabContent" v-disable-all="isReadonly">
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab1') }"
              id="tab1"
          >
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      label="Полное наименование организации"
                      v-model="item.nameFull"
                      placeholder="Введите наименование организации"/>
                  <div class="invalid-msg" v-if="v$.item.nameFull.$error">
                    <template v-if="v$.item.nameFull.maxLength.$invalid">Максимальная длина поля
                      {{ v$.item.nameFull.maxLength.$params.max }} символов.
                    </template>
                    <template v-else>Введите данные</template>
                  </div>

                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      v-model="item.name"
                      placeholder="Краткое наименование"
                      label="Краткое наименование"
                  />
                  <div class="invalid-msg" v-if="v$.item.name.$error">
                    <template v-if="v$.item.name.maxLength.$invalid">Максимальная длина поля
                      {{ v$.item.name.maxLength.$params.max }} символов.
                    </template>
                    <template v-else>Введите данные</template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Муниципальный район (городской округ)</label>
                  <Select2
                      class="select2"
                      :options="districtList"
                      :settings="select2Settings"
                      v-model="item.districtId"

                  />
                  <div class="invalid-msg" v-if="v$.item.districtId.$error">Введите данные</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Вид деятельности</label>
                  <Select2
                      class="select2"
                      :options="kindActivityList"
                      :settings="select2Settings"
                      v-model="item.kindActivityId"
                      v-on:select="changeKindActivity"
                      style="width: 100%"
                  />
                  <div class="invalid-msg" v-if="v$.item.kindActivityId.$error">Введите данные</div>
                </div>
              </div>
            </div>

            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Форма собственности</label>
                  <Select2
                      class="select2"
                      :options="opfParentList"
                      :settings="select2Settings"
                      v-model="item.opfParentId"
                      v-on:select="changeOpfParent"
                      style="width: 100%"
                  />
                  <div class="invalid-msg" v-if="v$.item.opfParentId.$error">Введите данные</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Организационно-правовая форма</label>
                  <Select2
                      class="select2"
                      :options="opfList"
                      :settings="select2Settings"
                      v-model="item.opfId"
                      style="width: 100%"
                  />
                  <div class="invalid-msg" v-if="v$.item.opfId.$error">Введите данные</div>
                </div>

              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Тип учреждения</label>
                  <Select2
                      class="select2"
                      :options="organizationTypeList"
                      :settings="select2Settings"
                      v-model="item.organizationTypeId"
                      v-on:select="loadOrganizationSubtypeList(item.organizationTypeId)"
                      style="width: 100%"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="form-group">
                    <label class="control-label">Вид учреждения</label>
                    <Select2
                        class="select2"
                        :options="organizationSubtypeList"
                        :settings="select2Settings"
                        v-model="item.organizationSubtypeId"
                        style="width: 100%"
                    />
                  </div>

                </div>
              </div>
            </div>
            <div class="row mt-10">

            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Фактический адрес</label>
                  <button class="btn p-0 px-2" title="Добавить" v-on:click="addAddress">

                    <i class="fa fa-plus"></i>
                  </button>
                  <template v-for="(el, key) in item.organizationAddresses"
                            v-bind:key="el.id">
                    <div
                        class="input-group mb-2"
                    >
                      <autocomplete-input v-model="el.address" :id="`addr_fact_${key}`" :url="fiasUrl" placeholder="Введите адрес"/>
                      <div class="input-group-append" v-if="key > 0">
                      <span v-if="!isReadonly"
                            class="input-group-text"
                            title="Удалить"
                            v-on:click="deleteAddress(el)"
                      ><i class="fa fa-trash"></i
                      ></span>
                      </div>
                    </div>
                    <div class="invalid-msg" v-if="v$.item.organizationAddresses.$error">Введите данные</div>
                  </template>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Юридический адрес</label>
                  <autocomplete-input v-model="item.address" id="addr_legal" :url="fiasUrl" placeholder="Юридический адрес"/>
                </div>
              </div>
            </div>
            <div class="row mt-10">
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group">
                  <component-input
                      placeholder="Введите телефон"
                      label="Телефон"
                      type="phoneCity"
                      v-model="item.phone"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <component-input
                      placeholder="Введите факс"
                      label="Факс"
                      type="phoneCity"
                      v-model="item.fax"/>
                </div>
              </div>
            </div>
            <div class="row mt-10">
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      placeholder="E-mail"
                      label="Электронная почта"
                      v-model="item.email"/>
                  <div class="invalid-msg" v-if="v$.item.email.$error">Введите корректные данные</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <component-input
                      placeholder="Официальный сайт"
                      label="Официальный сайт"
                      v-model="item.www"/>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group">
                  <component-input
                      placeholder="График работы"
                      label="График работы (общий)"
                      v-model="item.schedule"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Руководитель (ФИО полностью, должность)</label>
                  <input class="form-control" v-model="item.leaderFio" v-on:blur="uppercase()" placeholder="(ФИО полностью, должность)" />

                  <!-- <component-input
                      placeholder="(ФИО полностью, должность)"
                      label="Руководитель"
                      v-model="item.leaderFio"/> -->
                </div>
              </div>
            </div>
            <div class="row mt-10">
            </div>
            <div class="row mt-10">
              <div class="col-md-3">
                <div class="form-group required">
                  <component-input
                      placeholder="ОГРН"
                      label="ОГРН"
                      v-model="item.ogrn"/>
                  <div class="invalid-msg" v-if="v$.item.ogrn.$error">Введите корректные данные</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Дата регистрации</label>
                  <date-component :disabled="isReadonly" v-model="item.created"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      v-model="item.inn"
                      label="ИНН"
                      placeholder="Введите ИНН"/>
                  <div class="invalid-msg" v-if="v$.item.inn.$error">Введите корректные данные</div>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group">
                  <component-input label="КПП"
                                   v-model="item.kpp"
                                   placeholder="КПП"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      label="Источник финансирования"
                      placeholder="Введите текст"
                      v-model="item.sourceFinancing"/>
                  <div class="invalid-msg" v-if="v$.item.sourceFinancing.$error">Введите данные</div>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="form-group col-md-3 required">
                <component-input label="Проектная мощность, чел-мест"
                                 v-model="item.projectCapacity"
                                 :required="true"
                                 placeholder="Проектная мощность, чел-мест"/>
              </div>
              <div class="form-group col-md-3 required">
                <component-input label="Фактическое наполнение, чел-мест"
                                 v-model="item.actualFilling"
                                 :required="true"
                                 :disabled="item.actualFillingLocked && !item.fillingActualizationNeeded"
                                 placeholder="Фактическое наполнение, чел-мест"/>
                <span v-if="item.fillingActualizationNeeded" class="text-danger">Данные подлежат актуализации</span>
              </div>
              <div class="form-group col-md-6 required" v-if="Number(item.opfParentId) === OpfPrivate">
                <component-input label="Численность ЛРАС, обеспеченных компенсацией стоимости услуг, чел"
                                 v-model="item.costCompensationPatientCount"
                                 :required="true"
                                 placeholder="Численность ЛРАС, обеспеченных компенсацией стоимости услуг, чел"/>
              </div>
            </div>

            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label mb-32"
                  >Разрешительные документы на осуществление деятельности</label
                  >
                  <button class="btn" title="Добавить" v-on:click="addLicense">
                    <i class="fa fa-plus"></i>
                  </button>

                  <div
                      class="table d-flex flex-column"
                      v-if="item.organizationLicenses.length > 0"
                  >

                    <div class="d-flex table-head  justify-content-between">
                      <div class="table-head__item">Тип</div>
                      <div class="table-head__item">Реквизиты</div>
                      <div class="table-head__item"></div>
                    </div>

                    <div>
                      <div class="d-flex table-body justify-content-between"
                           v-for="(el, key) in item.organizationLicenses"
                           v-bind:key="el.id"
                      >
                        <div class="table-body__item">
                          <input
                              type="text"
                              class="form-control form-control--width"
                              v-model="item.organizationLicenses[key].type"
                          />
                        </div>
                        <div class="table-body__item">
                          <input
                              type="text"
                              class="form-control form-control--width"
                              v-model="item.organizationLicenses[key].brief"
                          />
                        </div>
                        <div v-if="!isReadonly" class="icon text-center table-body__item">
                          <i
                              class="fas fa-trash ico-delete"
                              v-on:click="deleteLicense(el)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-10">
              <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="isStop" id="chAgree">
                  <label for="chAgree" class="form-check-label control-label">Деятельность прекращена</label>
              </div>
            </div>
          </div>
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab2') }"
              id="tab2"
          >
            <div class="table d-flex flex-column" v-if="item.organizationOptions.length > 0">
              <div class="table-head--two mb-16">
                <div class="d-flex table-head">
                  <div v-if="!isReadonly" class="table-head__item col6"></div>
                  <div class="table-head__item col1">Услуга</div>
                  <div class="table-head__item col2">Описание</div>
                  <div class="table-head__item col3">Условия оказания услуги</div>
                  <div class="table-head__item col4">Договор</div>
                  <div class="table-head__item col5">Заявление</div>
                </div>
                <div class="d-flex table-body flex-column justify-content-between">
                  <div class="d-flex flex-row p-0" v-for="(option, index) in item.organizationOptions"
                       v-bind:key="option.id">
                    <div v-if="!isReadonly" class="table-body__item col6 icon"><i
                        class="fas fa-trash ico-delete"
                        @click="deleteOption(option)"></i>
                    </div>
                    <div class="table-body__item col1">
                      <Select2
                          class="select2"
                          :options="serviceTypeList"
                          :settings="select2Settings"
                          v-model="option.serviceTypeId"
                          style="width: 100%"
                      />
                      <div class="invalid-msg" v-if="option.serviceTypeId == 0 && v$.item.organizationOptions.$error">Необходимо заполнить поле</div>

                    </div>
                    <div class="table-body__item col2"><input type="text" class="form-control"
                                                              v-model="option.brief">
                      <div class="invalid-msg" v-if="!option.brief.length && v$.item.organizationOptions.$error">
                        Необходимо заполнить поле
                      </div>
                    </div>
                    <div class="table-body__item col3"><input type="text" class="form-control"
                                                              v-model="option.condition">
                      <div class="invalid-msg" v-if="!option.condition.length && v$.item.organizationOptions.$error">Необходимо заполнить поле</div>
                    </div>
                    <div class="table-body__item col4">
                      <file-upload width="100%" :entity="option"
                                   @deleteFile="removeFile('contractFile', option)"
                                   prop-name="contractFile"
                                   :entity-index="index"
                                   :readonly='isReadonly'
                                   @uploaded="fileUploaded"/>
                      <div class="invalid-msg" v-if="!option.contractFileId && v$.item.organizationOptions.$error">Необходимо заполнить поле</div>

                    </div>
                    <div class="table-body__item col5">
                      <file-upload :entity="option" prop-name="statementFile"
                                   width="100%"
                                   :entity-index="index"
                                   :readonly="isReadonly"
                                   @deleteFile="removeFile('statementFile', option)"
                                   @uploaded="fileUploaded"/>
                      <div class="invalid-msg" v-if="!option.statementFileId && v$.item.organizationOptions.$error">Необходимо заполнить поле</div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="btn card-footer__btn--blue" @click="addOption()">Добавить услугу</button>
<!--              <div class="invalid-msg" v-if="v$.item.organizationOptions.$error">Необходимо заполнить все-->
<!--                поля-->
<!--              </div>-->
            </div>
          </div>
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab3') }"
              id="tab3"
          >
            <div class="overflow-auto" :class="{'mb-16': item.organizationSchedules.length}">
              <table class="table table-bordered table-head--two"
                     v-if="item.organizationSchedules.length > 0">
                <thead>
                <tr>
                  <th></th>
                  <th>Специалист</th>
                  <th>ФИО</th>
                  <th>пн</th>
                  <th>вт</th>
                  <th>ср</th>
                  <th>чт</th>
                  <th>пт</th>
                  <th>сб</th>
                  <th>вс</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="scheduleItem in item.organizationSchedules" v-bind:key="scheduleItem.id">
                  <td v-if="!isReadonly" class="icon"><i class="fas fa-trash ico-delete"
                                                         v-on:click="deleteSchedule(option)"></i></td>
                  <td>
                    <input type="text" class="form-control" v-model="scheduleItem.name">
                  </td>
                  <td>
                    <input type="text" class="form-control" v-model="scheduleItem.fio">
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day1From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day1To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day2From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day2To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day3From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day3To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day4From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day4To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day5From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day5To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day6From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day6To">
                    </div>
                  </td>
                  <td>
                    <div class="input-group">
                      <input type="text" class="form-control time"
                             v-model="scheduleItem.day7From">
                      <div><span class="input-group-text">-</span></div>
                      <input type="text" class="form-control time" v-model="scheduleItem.day7To">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div>
              <button class="btn card-footer__btn--blue" @click="addSchedule()">Добавить специалиста
              </button>
            </div>
          </div>
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab4') }"
              id="tab4"
          >
            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Используемые в организации методики (технологии)
                    реабилитации (абилитации)</label>
                  <textarea class="form-control form-control--textarea"
                            v-model="item.rehabilitationMethods"></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Обеспеченность специалистами для реализации
                    реабилитационных мероприятий</label>
                  <textarea class="form-control form-control--textarea"
                            v-model="item.rehabilitationPeople"></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Имеющееся в организации оборудование, ТСР для
                    реализации реабилитационных мероприятий</label>
                  <textarea class="form-control form-control--textarea"
                            v-model="item.rehabilitationEquipment"></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Сведения о зданиях, сооружениях, помещениях
                    организации, используемых при предоставлении реабилитационных и иных
                    услуг</label>
                  <textarea class="form-control form-control--textarea"
                            v-model="item.rehabilitationBuilding"></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">График заездов на текущий год (для организаций,
                    оказывающих услуги в стационарной форме и полустационарной форме)</label>
                  <textarea class="form-control form-control--textarea"
                            v-model="item.rehabilitationSchedule"></textarea>
                </div>
              </div>
            </div>


            <div class="row mt-10">
              <div class="col-md-6">
                <button class="btn btn-primary btn-unload" @click="exportWord" v-if="item.id"
                        data-ignore-disable="true">
                  <i class="fa fa-word"></i> Выгрузить
                </button>
              </div>
            </div>
          </div>
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab5') }"
              id="tab5"
          >
            <div class="row">
              <div class="col-md-6">

                <l-map v-if="isActive('tab5')" ref="myMap" style="height:50vh"
                       :zoom="10"
                       :center="mapCurrentCenter"
                       @update:center="mapCenterUpdate">
                  <l-tile-layer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  ></l-tile-layer>
                  <template v-for="el in item.organizationAddresses"
                            :key="el.id">
                    <l-marker v-if="el.lat && el.lng"
                              :lat-lng="el" :icon="getMarkerIcon(false)"
                    >
                      <l-popup :content="el.address"/>
                    </l-marker>
                  </template>

                  <l-marker v-if="mapMarker"
                            :lat-lng="mapMarker" draggable="true" @dragend="mapMarkerDragend"
                            :icon="getMarkerIcon(true)"
                  >
                    <l-popup :content="'(' + mapMarker.lat + ';' + mapMarker.lng + ')'"/>
                  </l-marker>

                </l-map>

              </div>
              <div class="col-md-6">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th></th>
                    <th class="w-50">Адрес</th>
                    <th class="w-25">Широта</th>
                    <th class="w-25">Долгота</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="(el, index) in item.organizationAddresses" :key="el.id"
                      :class="{ 'bg-info': el === mapChooseRow }">
                    <td>{{ index + 1 }}</td>
                    <td>{{ el.address }}</td>
                    <td>{{ el.lat }}</td>
                    <td>{{ el.lng }}</td>
                    <td>
                      <template v-if="el === mapChooseRow">
                        <button class="btn" v-on:click="mapMarkerSave(el, false)"><i
                            class="fas fa-save" title="Сохранить"></i></button>
                        <button v-if="!isReadonly" class="btn"
                                v-on:click="mapMarkerSave(el, true)"><i
                            class="fas fa-trash-alt" title="Удалить"/></button>
                        <button class="btn" v-on:click="mapMarkerClear"><i class="fas fa-redo"
                                                                           title="Отменить"></i>
                        </button>
                      </template>
                      <template v-else>
                        <button class="btn" v-on:click="mapChooseElement(el)"><i
                            class="fas fa-pen" title="Редактировать"></i></button>
                      </template>
                    </td>
                  </tr>

                  </tbody>

                </table>

              </div>
            </div>


          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="float-right">
          <button type="button" class="btn card-footer__btn--blue mr-2" :class="{ 'disabled': inProcess }"
                  v-on:click="save" v-if="!isReadonly">Сохранить
          </button>
          <button type="button" class="btn card-footer__btn" v-on:click="close">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import API from "../api/organizations";
import Inputmask from 'inputmask';
import "leaflet/dist/leaflet.css"
import {LMap, LMarker, LTileLayer, LPopup} from "@vue-leaflet/vue-leaflet";
import {latLng} from "leaflet";
import { HereProvider } from 'leaflet-geosearch';
import {email, maxLength, required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import PageHeader from "@/common/components/page/PageHeader";
import DateComponent from "@/common/components/DateComponent"
import Utils from "../../../common/utils";
import disableAll from "../../../common/directives/disable-all";
import ComponentInput from "@/common/components/ComponentInput";
import FileUpload from "@/common/components/FileUpload";
import security from "../../../common/mixins/security";
import AutocompleteInput from "../../../common/components/AutocompleteInput";

const selectValidator = (value) => value > 0;
const ogrnValidator = (value) => value === null || value === undefined || value === '' || new RegExp("^[0-9]{13}$", "g").test(value);
const innValidator = (value) => value === null || value === undefined || value === '' || (new RegExp("^[0-9]{10,12}$", "g").test(value) && (value.length == 10 || value.length == 12));
const mapSearchProvider = new HereProvider({
  params: {
    apiKey: Constants.mapSearchApiKey,
    'accept-language': 'ru', // render results in Russia
    countrycodes: 'ru', // limit search results to the Russia
  }
});


function addressValidator(value) {
  return !!(value && value.length && value[0].address);
}

function optionsValidator(value) {
  if (value === null || value === undefined || value.length === 0)
    return true;

  var isValid = true;
  value.forEach(function (el) {
    if (!el.brief || !el.condition || el.serviceTypeId <= 0 || !el.contractFileId || !el.statementFileId)
      isValid = false;
  });

  return isValid;
}

export default {
  name: "OrganizationCard",
  components: {
    AutocompleteInput,

    FileUpload,
    ComponentInput,
    PageHeader,
    DateComponent,
    LMap,
    LMarker,
    LTileLayer,
    LPopup
  },
  directives: {
    'disable-all': disableAll
  },
  mixins: [security],
  data() {
    return {
      id: this.$route.params.id,
      isReadonly: this.$route.params.action === "view",
      inProcess: false,
      isStop: false,
      item: {
        isActive: true,
        isOrgan: false,
        districtId: 0,
        kindActivityId: 0,
        opfId: 0,
        opfParentId: 0,
        organizationTypeId: 0,
        organizationSubtypeId: 0,
        organizationAddresses: [{address: ""}],
        organizationLicenses: [],
        organizationOptions: [],
        organizationSchedules: [],
        organizationFiles: []
      },
      activeItem: "tab1",

      select2Settings: Constants.select2Settings,

      districtList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      serviceTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      opfParentList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      opfList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      organizationTypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      organizationSubtypeList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      kindActivityList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],

      mapMarker: null,
      mapChooseRow: null,
      mapCurrentCenter: latLng(56.30, 44.01),

      OpfPrivate: 3,

      fiasUrl: Constants.fiasApiUrl
    };
  },
  created() {
    //this.checkPermissions([Constants.OrganizationEdit, Constants.OrganizationView], 'Organization', this.id);
    this.loadPage();

    Utils.loadSelectOptions("kindActivity", this.kindActivityList);
    Utils.loadSelectOptions("district", this.districtList);
    Utils.loadSelectOptions("serviceType", this.serviceTypeList);
    Utils.loadSelectOptions("opf", this.opfParentList, {parentId: -1});
    Utils.loadSelectOptions("organizationType", this.organizationTypeList);
  },
  methods: {
    getMarkerIcon(isTemp) {
      return Utils.getMarkerIcon(this.item.kindActivityId, isTemp);
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    loadPage() {
      console.log("------- loadPage");
      if (this.id > 0) {
        API.find(this.id).then((response) => {
          this.item = response.data;
          this.isStop = !this.item.isActive;
          this.loadServiceTypeList(this.item.kindActivityId);
          this.loadOrganizationTypeList(this.item.kindActivityId);
          this.loadOrganizationSubtypeList(this.item.organizationTypeId);
          this.loadOpfList(this.item.opfParentId);

          if (
              !this.item.organizationAddresses ||
              !this.item.organizationAddresses.length
          ) {
            this.item.organizationAddresses = [{address: ""}];
          }

          this.$nextTick(function () {
            var im = new Inputmask("99:99");
            im.mask(document.querySelectorAll(".time"));
          });
        });
      }
    },

    addAddress() {
      this.item.organizationAddresses.push({address: ""});
    },
    deleteAddress(el) {
      this.item.organizationAddresses.splice(
          this.item.organizationAddresses.indexOf(el),
          1
      );
    },
    addLicense() {
      this.item.organizationLicenses.push({type: "", brief: ""});
    },
    deleteLicense(el) {
      this.item.organizationLicenses.splice(
          this.item.organizationLicenses.indexOf(el),
          1
      );
    },
    addOption() {
      this.item.organizationOptions.push({
        serviceTypeId: 0,
        brief: "",
        condition: "",
        contractFileId: null,
        contractFile: null,
        statementFileId: null,
        statementFile: null
      });
    },
    deleteOption(el) {
      this.item.organizationOptions.splice(
          this.item.organizationOptions.indexOf(el),
          1
      );
    },
    addSchedule() {
      this.item.organizationSchedules.push({
        name: "", fio: ""
        , day1From: "", day1To: ""
        , day2From: "", day2To: ""
        , day3From: "", day3To: ""
        , day4From: "", day4To: ""
        , day5From: "", day5To: ""
        , day6From: "", day6To: ""
        , day7From: "", day7To: ""
      });

      this.$nextTick(function () {
        var im = new Inputmask("99:99");
        im.mask(document.querySelectorAll(".time"));
      });
    },
    deleteSchedule(el) {
      this.item.organizationSchedules.splice(
          this.item.organizationSchedules.indexOf(el),
          1
      );
    },

    loadOrganizationSubtypeList(typeId) {
      Utils.loadSelectOptions(
          "organizationSubtype",
          this.organizationSubtypeList,
          {typeId: typeId},
          true
      );
    },
    loadOrganizationTypeList(kindActivityId) {
      Utils.loadSelectOptions(
          "organizationType",
          this.organizationTypeList,
          {kindActivityId: kindActivityId},
          true
      );
    },
    loadServiceTypeList(kindActivityId) {
      Utils.loadSelectOptions(
          "serviceType",
          this.serviceTypeList,
          {kindActivityId: kindActivityId},
          true
      );
    },
    loadOpfList(parentId) {
      Utils.loadSelectOptions(
          "opf",
          this.opfList,
          {parentId: parentId},
          true
      );
    },
    changeOpfParent() {
      this.loadOpfList(this.item.opfParentId);
      this.item.opfId = 0;
    },
    changeKindActivity() {
      this.loadOrganizationTypeList(this.item.kindActivityId);
      this.loadServiceTypeList(this.item.kindActivityId);
      while (this.organizationSubtypeList.length > 1) this.organizationSubtypeList.pop();
    },
    uppercase() {
      var parts = this.item.leaderFio.split(' ');
      this.item.leaderFio = parts.map(function (el) {
        if (el === "" || el === null || el === undefined)
          return;
        return el.charAt(0).toUpperCase() + el.slice(1);
      }).join(' ');
    },
    save() {
      if (this.inProcess)
        return;

      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      this.inProcess = true;

      const toSave = Object.assign({}, this.item);
      if (toSave.organizationTypeId == 0)
        toSave.organizationTypeId = null;
      if (toSave.organizationSubtypeId == 0)
        toSave.organizationSubtypeId = null;
      toSave.isActive = !this.isStop;

      API.save(toSave).then((response) => {
        this.inProcess = false;
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success && (this.item.id <= 0 || this.item.id === undefined)) {
          this.$router.push({name: 'Organizations', query: { page: this.$route.query.page }});
        } else {
          this.loadPage();
        }
      }).catch(() => {
        this.inProcess = false;
        Constants.alert.fire('Ошибка', 'Произошла ошибка', 'error');
      });
    },
    close() {
      this.$router.push({name: 'Organizations', query: { page: this.$route.query.page }});
    },


    mapChooseElement(el) {
      //если есть координаты отцентровать на ней карту и поставить маркер, если не то на текущую точку
      this.mapChooseRow = el;
      if (el.lat && el.lng) {
        this.mapMarker = latLng(el.lat, el.lng);
        this.mapCurrentCenter = latLng(el.lat, el.lng);
      } else {
        //попытаться найти по адресу
        this.mapMarker = this.mapCurrentCenter;//latLng(56.30, 44.01); //this.$refs.myMap.mapObject.getCenter();
        mapSearchProvider.search({ query: el.address }).then((results) => {
          if(results && results.length > 0) {
            this.mapMarker = latLng(results[0].y, results[0].x);
            this.mapCurrentCenter = this.mapMarker;
          }
        });        
      }
    },
    mapCenterUpdate(center) {
      this.mapCurrentCenter = center;
    },
    mapMarkerDragend(e) {
      this.mapMarker = e.target._latlng;
    },
    mapMarkerSave(el, isDelete) {
      el.lat = null;
      el.lng = null;

      if (!isDelete) {
        var lat = this.mapMarker.lat;
        var lng = this.mapMarker.lng;
        this.$nextTick(function () {
          el.lat = lat;
          el.lng = lng;
        });
      }

      this.mapChooseRow = null;
      this.mapMarker = null;
    },
    mapMarkerClear() {
      this.mapChooseRow = null;
      this.mapMarker = null;
    },

    fileUploaded(e) {
      let entity = this.item.organizationOptions[e.entityIndex];
      entity[e.propName + 'Id'] = e.data.id;
      entity[e.propName] = e.data;
    },

    removeFile(propName, el) {
      el[propName] = null;
      el[propName + "Id"] = null;
    },
    exportWord() {
      API.exportWord(this.item.id)
          .then(response => {
            console.log(response.headers["content-type"]);
            const blob = new Blob([response.data], {type: response.headers["content-type"]});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = "Реабилитационные мероприятия.docx";
            link.click();
            URL.revokeObjectURL(link.href);
          });
    },
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        name: {required, maxLength: maxLength(200)},
        nameFull: {required, maxLength: maxLength(200)},
        districtId: {required, selectValidator},
        kindActivityId: {required, selectValidator},
        opfParentId: {required, selectValidator},
        opfId: {required, selectValidator},
        organizationAddresses: {addressValidator},
        email: {required, email},
        ogrn: {required, ogrnValidator},
        inn: {required, innValidator},
        sourceFinancing: {required},
        organizationOptions: {optionsValidator}
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/modules/organization/views/index";
@import 'src/modules/ras/views/index';

.select2-dropdown {
  position: static !important;
}

.btn-unload {
  border-radius: 24px;
}

.form-control {
  max-width: 100%;
  background: $white;
  border: 1px solid $gray-light1;
  box-sizing: border-box;
  border-radius: 6px;
}
.control-label{
  font-weight: 400 !important;
  color: $gray-dark;
  font-size: 16px;
}
</style>
